import { TFunction } from 'i18next'
import { z, ZodType } from 'zod'

import { BankAccount } from '@features/bankAccounts/types/bankAccount'

export interface EditConnectedBankAccountForm {
  customAccountName?: string
  reconciliationStartDate: Date | null
}

export type EditConnectedBankAccountFormSchema = ZodType<EditConnectedBankAccountForm>

export const getValidationSchema = (t: TFunction): EditConnectedBankAccountFormSchema =>
  z.object({
    customAccountName: z.string().trim().max(20, t('bank.account.modal.account_custom_name.max_length')),
    reconciliationStartDate: z.date().nullable(),
  })

export const getDefaultValues = (bankAccount?: BankAccount): EditConnectedBankAccountForm => ({
  customAccountName: bankAccount?.customAccountName ?? '',
  reconciliationStartDate: bankAccount?.reconciliationStartDate ? new Date(bankAccount.reconciliationStartDate) : null,
})
